module.exports = "/_next/static/images/video_id_7137396344695606571-f11a7ef246103cf64d72a5df71a83831.jpg";